// Inspiration item overlay functionaility. Used by inspiration component on desktop.

// Initializes the inspiration items
function initialize() {

  const inspirationItemsSelector = '.wf-inspiration-items';
  const inspirationItemSelector = '.wf-inspiration-item';
  const inspirationOverlayOpenButtonSelector = '.wf-inspiration-overlay-button-open';
  const inspirationOverlayCloseButtonSelector = '.wf-inspiration-overlay-button-close';

  const inspirationOverlayActiveClass = 'wf-inspiration-overlay-active';
  const inspirationOverlayClosingClass = 'wf-inspiration-overlay-closing';
  const inspirationOverlayClosingDelay = 500;

  const inspirationOverlayOpenButtons = document.querySelectorAll(inspirationOverlayOpenButtonSelector);
  const inspirationOverlayCloseButtons = document.querySelectorAll(inspirationOverlayCloseButtonSelector);

  // Open inspiration overlay on button click
  inspirationOverlayOpenButtons.forEach(button => {
    button.addEventListener('click', event => {
      const inspirationItem = button.closest(inspirationItemSelector);
      if (inspirationItem) {
        inspirationItem.classList.add(inspirationOverlayActiveClass);
      }
    });
  });

  // Close inspiration overlay on button click
  inspirationOverlayCloseButtons.forEach(button => {
    button.addEventListener('click', event => {
      const inspirationItem = button.closest(inspirationItemSelector);
      if (inspirationItem) {
        inspirationItem.classList.remove(inspirationOverlayActiveClass);

        inspirationItem.classList.add(inspirationOverlayClosingClass);
        setTimeout(function() {
          inspirationItem.classList.remove(inspirationOverlayClosingClass);
        }, inspirationOverlayClosingDelay);
      }
    });
  });
}

initialize();